// oxlint-disable typescript/no-non-null-assertion
import {Anchor, createTopAnchor} from '@cypro/ui/components/ui/infinite-data-table'
import {ListPatientsInput, queries} from '@cypro/engine/queries'
import {Patient} from '@cypro/engine/schema'
import {useQuery} from '@rocicorp/zero/react'
import {useEffect, useMemo, useState} from 'react'

export function useGetPatients({
  sort = {dir: 'desc', field: 'createdAt'},
  filters,
  limit,
}: Omit<Partial<ListPatientsInput>, 'cursor'> = {}) {
  const [anchor, setAnchor] = useState<Anchor<Patient>>(createTopAnchor<Patient>())
  const cursor = anchor.startRow
    ? {
        id: anchor.startRow.id,
        direction: anchor.direction,
        createdAt: anchor.startRow.createdAt ?? 0,
        sortableGivenName: anchor.startRow.sortableGivenName ?? undefined,
        sortableFamilyName: anchor.startRow.sortableFamilyName ?? undefined,
        birthDate: anchor.startRow.birthDate ?? undefined,
      }
    : undefined

  const query = queries.patients.listPatients({
    cursor,
    sort,
    filters,
    limit,
  })

  const [patients, meta] = useQuery(query)

  const filtersHash = useMemo(() => JSON.stringify(filters), [filters])
  useEffect(() => {
    setAnchor(createTopAnchor<Patient>())
  }, [sort?.dir, sort?.field, filtersHash, limit])

  return {
    query,
    meta,
    patients,
    anchor,
    fetchMore: setAnchor,
    canFetchMore: patients.length === limit,
    isFetching: meta.type === 'unknown',
  }
}
